//采购管理下的公用方法
export default {
  data() {
    return {
      //供应商列表
      supplier_arr:[],
      supplier_zh_name_code:[],
      request_type_arr:['采购付款','运费付款','报关费用付款', '报关费用报销'],
      payment_arr:{//采购合同付款状态
        "10":{"id":"10", "value":"未付款"},
        "20":{"id":"20", "value":"部分付款"},
        "30":{"id":"30", "value":"已付款"},
        "40":{"id":"40", "value":"已作废"},
      },
      require_arr:{//采购合同请款状态
        "10":{"id":"10", "value":"未请款"},
        "20":{"id":"20", "value":"部分请款"},
        "30":{"id":"30", "value":"已请款"},
        "40":{"id":"40", "value":"已作废"}
      },
      stcokIn_arr:{//采购合同入库状态
        "10":{"id":"10", "value":"未入库"},
        "20":{"id":"20", "value":"部分入库"},
        "30":{"id":"30", "value":"已入库"},
        "40":{"id":"40", "value":"已作废"}
      },

      approve_arr:{//采购合同审核状态
        "1":{"id":"1", "value":"待审核"},
        "2":{"id":"2", "value":"审核中"},
        "3":{"id":"3", "value":"已驳回"},
        "4":{"id":"4", "value":"已通过"},
        "5":{"id":"5", "value":"已作废"}
      }
    }
  },
  methods: {
      getSupplier(){ //供应商列表
        _api.get('/purchase/supplier/index',{page: 1,pageSize: 10000,status: 1}).then(res=>{
          this.supplier_arr = res.data.list ? res.data.list : [];
          let list= res.data.list;
          list.forEach(item => {
            this.supplier_zh_name_code.push( {
              zh_supplier_name: item.zh_supplier_name,
              supplier_code:item.supplier_code,
              pre_pay_proportion:item.pre_pay_proportion,
              settlement_method:item.settlement_method,
              id:item.id,
             })

          });


        })
      },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/purchase/index.js